import React, { useState } from 'react';
import { Button, Spin, Modal, Form, Input, message } from 'antd';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import assign from 'lodash/assign';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { productMangement } from '../../redux/actions/productAction';
import { CATEGORY_CREATED_SUCCESS } from '../../constants/messages';

function AddCategory(props) {
  const { categoryId, refreshCategories, companyId } = props;
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const toggleLoginModal = () => {
    setShowLoginModal(!showLoginModal);
  };

  const getHeading = () => {
    switch (categoryId) {
      case 1:
        return 'Add New Main Category';
      case 2:
        return 'Add New Sub Category';
      case 3:
        return 'Add New Sub-Sub Category';
      case 4:
        return 'Add New Sub-Sub-Sub Category';
      default:
        return '';
    }
  };

  const onFinish = (values) => {
    const payload = assign(values, {
      company_id: companyId,
      type: categoryId,
    });
    setLoading(true);
    dispatch(productMangement('create.product_category', payload))
      .then((result) => {
        setLoading(false);
        toggleLoginModal();
        refreshCategories(`category_id_${categoryId}`, get(result, 'data'));
        message.success(CATEGORY_CREATED_SUCCESS);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        className="add-categoty-link"
        icon={<PlusOutlined />}
        onClick={toggleLoginModal}
        type="link"
      >
        {getHeading()}
      </Button>
      <Modal
        width="40%"
        className="common-modal product-image-modal "
        destroyOnClose
        closable={false}
        open={showLoginModal}
        onOk={toggleLoginModal}
        onCancel={toggleLoginModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container">
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleLoginModal();
                }}
              />
              {getHeading()}
            </div>
            <div className="mt-40">
              <Form
                name="basic"
                layout="horizontal"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
                requiredMark={false}
              >
                <div className="mt-20">
                  <Form.Item
                    label="Category Name "
                    name="name"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input category name!',
                      },
                      {
                        min: 3,
                        message:
                          'Category name should be of atleast 3 character!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Category Name" />
                  </Form.Item>
                </div>
                <div className="mt-40">
                  <Form.Item
                    label="Description"
                    name="description"
                    className="form-item"
                  >
                    <Input placeholder="Enter description" />
                  </Form.Item>
                </div>

                <div className="mt-20">
                  <Button type="primary" block htmlType="submit">
                    Create
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default AddCategory;
